import { useMutation } from 'react-query';
import { useToast } from 'hooks/useToast';
import { trackGroupConfigAction } from 'services/analytics/trackGroupConfigAction';
import {
  useDashboardGroupId,
  useDashboard,
  useDashboardGroupType,
} from 'state/dashboard';
import { GROUP_TYPE } from 'utils/constants';

type TUpdateGroupParams = {
  onSuccessCallback?: (arg0: number) => void;
  onErrorCallback?: () => void;
};

export const useUpdateGroup = () => {
  const [type] = useDashboardGroupType();
  const [dashboardGroupId] = useDashboardGroupId();
  const { updateGroup: executeUpdateGroupRequest } = useDashboard();
  const { renderCustomToast: toast } = useToast();

  const onError = (onErrorCallback?: () => void) => {
    if (onErrorCallback) {
      onErrorCallback();
    }
    toast({
      title: 'Error',
      description: 'Something went wrong - Saved search update failed',
      status: 'error',
    });
  };

  const updateGroup = useMutation({
    mutationFn: async ({ onSuccessCallback, onErrorCallback }: TUpdateGroupParams) => {
      const response = await executeUpdateGroupRequest();
      if (response?.status === 200) {
        toast({
          title: 'Success',
          description: 'Saved search updated successfully',
          status: 'success',
        });
        trackGroupConfigAction({
          group_id: String(dashboardGroupId),
          group_type: type === GROUP_TYPE.PROJECT ? 'project_group' : 'company_group',
          click_action: 'update_group',
        });
        if (onSuccessCallback) {
          onSuccessCallback(Number(dashboardGroupId));
        }
      } else {
        onError(onErrorCallback);
      }
    },
    onError: (_, { onErrorCallback }) => {
      onError(onErrorCallback);
    },
  });

  return { updateGroup };
};
